<template>
  <div class="wrapper-inside">
    <b-card>
      <div v-if="loading">
        {{ $t('generic.loading', 'Loading') }}...
      </div>
      <div v-if="!loading && error != ''">
        {{ error }} {{ $t('generic.try-again', 'Please try again') }}.
      </div>
      <b-table
        v-if="!loading && error === ''"
        striped
        hover
        :items="roles"
        :fields="fields"
      >
        <template
          slot="actions"
          slot-scope="data"
        >
          <font-awesome-icon
            v-if="data.item.name === 'super-admin'"
            class="mr-2"
            icon="lock"
          />
          <font-awesome-icon
            v-else
            class="mr-2"
            icon="eye"
            @click="editPermissions(data.item)"
          />
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      error: '',
      fields: [
        {
          key: 'id',
        },
        {
          key: 'name',
          label: 'Role'
        },
        {
          key: 'created_at',
          label: 'Date'
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      roles: ''
    }
  },
  async mounted() {
    // CHECK FOR PERMISSIONS
    if(!this.$can('roles_manage') && !this.$hasRole(['super-admin'])) {
      this.$router.push({ name: 'not-found' });
      return;
    }
    // ---
    await this.axios
      .get('/roles')
      .then( response => this.roles = response.data )
      .catch( (error) => {
        this.error = error.response.data.error;
      });
    this.loading = false;
    if(this.roles === '' && !this.error) {
      this.error = 'No roles yet!';
    }
  },
  methods: {
    editPermissions(item) {
      this.$router.push({ name: 'admin-permissions', params: { id: item.id } })
    }
  }
}
</script>
